export default "__VITE_ASSET__f722f81e__"